import { env } from 'core/constants/env.constants';
import { ONE_TRUST_CDN_ORIGIN } from 'core/platform/one-trust.constants';
import { Helmet } from 'react-helmet';

const oneTrustId = env.VITE_ONE_TRUST_ID;

export const AppHeadComponent: React.FC = () =>
  oneTrustId ? (
    <Helmet>
      <script
        type="text/javascript"
        src={`${ONE_TRUST_CDN_ORIGIN}/consent/${oneTrustId}/OtAutoBlock.js`}
      />
      <script
        src={`${ONE_TRUST_CDN_ORIGIN}/scripttemplates/otSDKStub.js`}
        data-document-language="true"
        type="text/javascript"
        data-domain-script={oneTrustId}
      />
    </Helmet>
  ) : undefined;
